import { css } from 'styled-components'

export const bannerKindStyles = css`
  &.kind-informational-primary {
    background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
    color: ${props => props.theme.palette.neutral.surface.lightContrast};
  }
  &.kind-promotional-primary {
    background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
    color: ${props => props.theme.palette.highlight.primary.lightContrast};
  }
  &.kind-promotional-primary-accent {
    background-color: ${props => props.theme.palette.highlight.primary.normalBackground};
    color: ${props => props.theme.palette.highlight.primary.normalContrast};
  }
  &.kind-promotional-secondary {
    background-color: ${props => props.theme.palette.highlight.tertiary.lightBackground};
    color: ${props => props.theme.palette.highlight.tertiary.lightContrast};
  }
  &.kind-success {
    background-color: ${props => props.theme.palette.messaging.success.lightBackground};
    color: ${props => props.theme.palette.messaging.success.lightContrast};
  }
  &.kind-warning {
    background-color: ${props => props.theme.palette.messaging.warning.lightBackground};
    color: ${props => props.theme.palette.messaging.warning.lightContrast};
  }
  &.kind-critical {
    background-color: ${props => props.theme.palette.messaging.critical.lightBackground};
    color: ${props => props.theme.palette.messaging.critical.lightContrast};
  }
  &.kind-lux-plus {
    background-color: ${props => props.theme.palette.product.luxPlus.background};
    color: ${props => props.theme.palette.product.luxPlus.contrast};
  }
  &.kind-loyalty-bronze {
    background: linear-gradient(to right, ${props => props.theme.palette.product.loyalty.bronze.normalBackground}, ${props => props.theme.palette.product.loyalty.bronze.lightBackground});
    color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
  }
  &.kind-loyalty-silver {
    background: linear-gradient(to right, ${props => props.theme.palette.product.loyalty.silver.normalBackground}, ${props => props.theme.palette.product.loyalty.silver.lightBackground});
    color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
  }
  &.kind-loyalty-gold {
    background: linear-gradient(to right, ${props => props.theme.palette.product.loyalty.gold.normalBackground}, ${props => props.theme.palette.product.loyalty.gold.lightBackground});
    color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }
  &.kind-loyalty-platinum {
    background: linear-gradient(to right, ${props => props.theme.palette.product.loyalty.platinum.normalBackground}, ${props => props.theme.palette.product.loyalty.platinum.lightBackground});
    color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
  }
  &.kind-loyalty-infinite {
    background: linear-gradient(to right, ${props => props.theme.palette.product.loyalty.infinite.normalBackground}, ${props => props.theme.palette.product.loyalty.infinite.lightBackground});
    color: ${props => props.theme.palette.product.loyalty.infinite.normalContrast};
  }
`
